import { useTranslation } from 'react-i18next';
import { useOneTrust } from './useOneTrust';

export type FooterLinkItem =
  | { type: 'link'; label: string; to: string; external?: boolean }
  | { type: 'action'; label: string; action: (() => void) | undefined };

const useFooterLinks = () => {
  const { t } = useTranslation();
  const { toggleConsentModal } = useOneTrust();

  const defaultFooterLinks: FooterLinkItem[] = [
    {
      type: 'link',
      label: t('footerLinks.termsOfUse'),
      to: 'terms-of-use',
      external: true
    },
    {
      type: 'link',
      label: t('footerLinks.privacy'),
      to: process.env.REACT_APP_PRIVACY_POLICY_LINK as string,
      external: true
    },
    {
      type: 'action',
      label: t('footerLinks.cookies'),
      action: toggleConsentModal
    }
  ];

  return defaultFooterLinks;
};

export default useFooterLinks;
